export default __webpack_public_path__ + "static/media/css.495a79bf.png";